import DataTableView from "@components/views/datatable-view";
import useInvoices from "./use-invoices";

const Invoices = () => {

    const { columns, invoices } = useInvoices();

    return (
        <DataTableView
            moduleName="Invoices"
            breadcrumbItems={{
                items: [
                    {
                        title : "Invoices",
                        active: true
                    }
                ]
            }}
            loading={false}
            tableProps={{
                data: invoices,
                columns
            }}/>
    );
};

export default Invoices;